import { useEffect, useState } from 'react';
import Modal from '../Modal';
import { repositorioTipoAtividade } from '../../sync/repositories/agricultura';
import { extrairMensagensErro } from '../../utils/errorUtils';

const TIPOS_PRINCIPAIS = [
  { value: 'plantio', label: 'Plantio' },
  { value: 'pulverizacao', label: 'Pulverização' },
  { value: 'colheita', label: 'Colheita' },
  { value: 'gradagem', label: 'Gradagem/Preparo Solo' },
  { value: 'adubacao', label: 'Adubação' },
  { value: 'semeadura', label: 'Semeadura' },
  { value: 'outros', label: 'Outros' },
];

const SUBCATEGORIAS_PULV = [
  { value: 'herbicida', label: 'Herbicida' },
  { value: 'inseticida', label: 'Inseticida' },
  { value: 'fungicida', label: 'Fungicida' },
  { value: 'acaricida', label: 'Acaricida' },
];

/**
 * Modal de cadastro rápido de Tipo de Atividade. As flags exige_maquina/
 * exige_funcionario/exige_insumo ficam com os mesmos defaults da tela
 * completa (true/true/false) — ajustáveis lá depois, se necessário.
 */
export default function ModalCadastroTipoAtividade({ isOpen, onClose, onSuccess }) {
  const [nome, setNome] = useState('');
  const [tipoPrincipal, setTipoPrincipal] = useState('');
  const [subcategoriaPulverizacao, setSubcategoriaPulverizacao] = useState('');
  const [salvando, setSalvando] = useState(false);
  const [erros, setErros] = useState([]);

  useEffect(() => {
    if (!isOpen) {
      setNome('');
      setTipoPrincipal('');
      setSubcategoriaPulverizacao('');
      setErros([]);
      setSalvando(false);
    }
  }, [isOpen]);

  const handleSalvar = async (e) => {
    e?.preventDefault?.();
    if (!nome.trim()) { setErros(['O nome é obrigatório.']); return; }
    if (!tipoPrincipal) { setErros(['Selecione o tipo principal.']); return; }
    setSalvando(true);
    setErros([]);
    try {
      const resp = await repositorioTipoAtividade.criar({
        nome: nome.trim(),
        tipo_principal: tipoPrincipal,
        subcategoria_pulverizacao: tipoPrincipal === 'pulverizacao' ? subcategoriaPulverizacao : '',
        exige_maquina: true,
        exige_funcionario: true,
        exige_insumo: false,
      });
      onSuccess?.(resp.data);
      onClose?.();
    } catch (error) {
      setErros(extrairMensagensErro(error));
    } finally {
      setSalvando(false);
    }
  };

  return (
    <Modal isOpen={isOpen} onClose={salvando ? () => {} : onClose} title="Cadastrar Tipo de Atividade">
      <form onSubmit={handleSalvar} className="space-y-4">
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">Nome *</label>
          <input
            type="text"
            value={nome}
            onChange={(e) => setNome(e.target.value)}
            className="w-full border border-gray-300 p-2 rounded focus:ring-2 focus:ring-green-300"
            placeholder="Ex: Pulverização de Herbicida"
            autoFocus
            disabled={salvando}
          />
        </div>
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">Tipo Principal *</label>
          <select
            value={tipoPrincipal}
            onChange={(e) => {
              setTipoPrincipal(e.target.value);
              if (e.target.value !== 'pulverizacao') setSubcategoriaPulverizacao('');
            }}
            disabled={salvando}
            className="w-full border border-gray-300 p-2 rounded focus:ring-2 focus:ring-green-300 bg-white"
          >
            <option value="">Selecione...</option>
            {TIPOS_PRINCIPAIS.map((t) => (
              <option key={t.value} value={t.value}>{t.label}</option>
            ))}
          </select>
        </div>
        {tipoPrincipal === 'pulverizacao' && (
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Subcategoria de Pulverização</label>
            <select
              value={subcategoriaPulverizacao}
              onChange={(e) => setSubcategoriaPulverizacao(e.target.value)}
              disabled={salvando}
              className="w-full border border-gray-300 p-2 rounded focus:ring-2 focus:ring-green-300 bg-white"
            >
              <option value="">Selecione...</option>
              {SUBCATEGORIAS_PULV.map((s) => (
                <option key={s.value} value={s.value}>{s.label}</option>
              ))}
            </select>
          </div>
        )}
        {erros.length > 0 && (
          <div className="bg-red-50 border border-red-200 text-red-700 text-sm rounded p-3 space-y-1">
            {erros.map((m, i) => <div key={i}>{m}</div>)}
          </div>
        )}
        <div className="flex justify-end gap-2 pt-2">
          <button type="button" onClick={onClose} disabled={salvando}
            className="px-4 py-2 rounded border border-gray-300 text-gray-700 hover:bg-gray-100 disabled:opacity-50">
            Cancelar
          </button>
          <button type="submit" disabled={salvando}
            className="px-4 py-2 rounded bg-blue-600 hover:bg-blue-700 text-white disabled:bg-blue-300">
            {salvando ? 'Salvando...' : 'Salvar'}
          </button>
        </div>
      </form>
    </Modal>
  );
}
